import React from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

const StyledTooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: help;

  .tooltip {
    visibility: hidden;
    width: 300px;
    background-color: #333;
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 8px 12px;
    position: absolute;
    z-index: 1000;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.1s;
    font-size: 12px;
    line-height: 1.4;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipContainer = () => {
  return (
    <StyledTooltipContainer>
      <p className="text-sm text-brand-grey-200">
        <FontAwesomeIcon icon={faInfoCircle}></FontAwesomeIcon> Accepted file
        types: .csv, .tsv, .txt
      </p>
      <div className="tooltip">
        To add multiple SKUs at once upload a file with a single column of SKUs,
        with one SKU per line.
      </div>
    </StyledTooltipContainer>
  );
};

export default TooltipContainer;
